import mixpanel from 'mixpanel-browser';

// Initialize with your Mixpanel project token
mixpanel.init('d6b8464c3958f7a82c6c0ab3fd4ed7ea', {
  debug: process.env.NODE_ENV !== 'production',
  track_pageview: false,
  persistence: 'localStorage'
});

const Mixpanel = {
  // Track any event
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  
  // Identify a user
  identify: (userId) => {
    mixpanel.identify(userId);
  },
  
  // Set user profile properties
  setUserProfile: (props) => {
    mixpanel.people.set(props);
  },
  
  // Track page views with detailed page information
  trackPageView: (pagePath, pageTitle = null) => {
    const pageProperties = {
      page_path: pagePath,
      page_url: window.location.origin + pagePath,
      page_title: pageTitle || document.title || pagePath.split('/').pop() || 'Unknown',
      referrer: document.referrer || 'direct',
      timestamp: new Date().toISOString(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight
    };
    
    mixpanel.track('Page View', pageProperties);
  },
  
  // Enhanced page tracking with additional properties
  trackEnhancedPageView: (pagePath, pageTitle = null, additionalProps = {}) => {
    const pageProperties = {
      page_path: pagePath,
      page_url: window.location.origin + pagePath,
      page_title: pageTitle || document.title || pagePath.split('/').pop() || 'Unknown',
      referrer: document.referrer || 'direct',
      timestamp: new Date().toISOString(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      ...additionalProps
    };
    
    mixpanel.track('Page View', pageProperties);
  },
  
  // Track feature usage - use this instead of trackPageView for new components
  trackFeatureUsed: (feature, action = 'Opened', additionalProps = {}) => {
    mixpanel.track('Feature Used', { 
      feature,
      action,
      ...additionalProps
    });
  },
  
  // Enhanced feature tracking with page information
  trackEnhancedFeature: (feature, action = 'Opened', additionalProps = {}) => {
    const pagePath = window.location.pathname;
    
    mixpanel.track('Feature Used', { 
      feature,
      action,
      page_path: pagePath,
      page_url: window.location.origin + pagePath,
      page_title: document.title || pagePath.split('/').pop() || 'Unknown',
      timestamp: new Date().toISOString(),
      ...additionalProps
    });
  },
  
  // Track specific actions within features
  trackFeatureAction: (feature, action, additionalProps = {}) => {
    mixpanel.track('Feature Action', {
      feature,
      action,
      ...additionalProps
    });
  },
  
  // Enhanced feature action tracking with page information
  trackEnhancedFeatureAction: (feature, action, additionalProps = {}) => {
    const pagePath = window.location.pathname;
    
    mixpanel.track('Feature Action', {
      feature,
      action,
      page_path: pagePath,
      page_url: window.location.origin + pagePath,
      page_title: document.title || pagePath.split('/').pop() || 'Unknown',
      timestamp: new Date().toISOString(),
      ...additionalProps
    });
  },
  
  // Track user engagement metrics
  trackEngagement: (metric, value, additionalProps = {}) => {
    mixpanel.track('User Engagement', {
      metric,
      value,
      ...additionalProps
    });
  },
  
  // Enhanced event tracking with additional properties
  trackEnhancedEvent: (name, props = {}) => {
    const enhancedProps = {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      path: window.location.pathname,
      ...props
    };
    
    mixpanel.track(name, enhancedProps);
  },
  
  // Reset user
  reset: () => {
    mixpanel.reset();
  }
};

export default Mixpanel;